const translations = {
	page_title: "Client",
	sub_pages: {
		legal_person_clients: {
			page_title: "Clients personnes morales",
		},
		physical_person_clients: {
			page_title: "Clients personnes physiques",
		},
		personal_information: {
			page_title: "Informations personnelles",
			modify_information: "Modifier les informations",
			see_spouse: "Voir la fiche du conjoint",
			edit_corporation_modal: {
				title: "Vérification",
				subtitle: "Veuillez vérifier les informations de votre client et de les compléter/modifier si nécessaire.",
			},
		},
		validated_subscriptions: {
			page_title: "Souscriptions validées",
			table: {
				columns: {
					name: "Nom du produit",
					validation_date: "Date de souscription",
					due_date: "Date de jouissance",
					payout_date: "Date de versement des premiers loyers",
					share_number: "Nombre de parts",
					amount_subscribed: "Montant souscrit (€)",
					estimation_amount: "Valorisation estimée*",
				},
			},
		},
		customer_insight: {
			page_title: "Connaissance client",
			no_data:
				"Il semble qu'aucune question de cette catégorie n'ait été complétée pour ce client.\n\nLes réponses que vous fournirez lors des souscriptions seront enregistrées ici. Elles permettront de vous faire gagner du temps en pré-remplissant les futures souscriptions de ce client.",
			sub_pages: {
				payment_method: {
					page_title: "Règlement",
				},
				patrimoine_revenus: {
					page_title: "Patrimoine et revenus",
				},
				finance_durable: {
					page_title: "Finance durable",
				},
				connaissance_experience: {
					page_title: "Connaissance et expérience",
				},
				test_adequation: {
					page_title: "Test d'adéquation",
				},
			},
		},
	},
};

export default translations;
